module.exports = __webpack_public_path__ + "images/interview-Accenture-2.svg";